import { primary_color } from "../../Helper/uiHelper";

const RowTitle = ({ title }) => {
  return (
    <div className={`permission-header subtitle1`} style={{ color: primary_color }}>
      {title?.replace(/<[^>]*>/g, '')}
    </div>
  )
}

export default RowTitle;